/**
 * Scene component extracted from BonusWorldScene
 */

class BonusWorldSceneComponent extends ScriptComponent {
    onCreate() {
        const mission = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0];
        this.bonusWorld = mission.bonusWorld;
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        const bundleName = this.bonusWorld.backgroundBundleId();

        this.sceneComponent.setStyling({
            bundle: bundleName,
            backgroundId: "background",
            animation: bundles[bundleName].jsons.background_spine
        });
        this.sceneComponent.setAudioStyles({
            res: bundles[bundleName].urls.music,
            delay: 1.0
        });
        this.sceneComponent.setBundles([BonusWorldConfig[this.bonusWorld.type].bundle, bundleName]);
    }

    onSceneLoaded() {
        this.rewardsView = new BonusWorldRewardsView(this.bonusWorld);
        this.node.addChild(this.rewardsView);

        this.levelViews = [];
        for (let levelNo = this.bonusWorld.levelsAmount - 1; levelNo >= 0; levelNo--) {
            const levelView = new BonusWorldLevelView(new BonusWorldLevel(this.bonusWorld, levelNo));
            this.node.addChild(levelView);
            this.levelViews.push(levelView);
        }

        cleverapps.environment.episodeNo = this.bonusWorld.config.episode;

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.BONUS_WORLD_DAU);
    }

    onReady() {
        this.onResize();
    }

    onResize() {
        this.levelViews.forEach((levelView) => {
            levelView.adjustPosition(this.node.background.scale);
        });

        this.rewardsView.adjustPosition(this.node.background.scale);
    }

    onDestruct() {
        this.bonusWorld.purge();
    }
}

Prefab.registerComponent("BonusWorldSceneComponent", BonusWorldSceneComponent);
